import React from 'react';
import {
  getChipLabel,
  getItemKey,
} from '@/views/creators/creator-crm/utils/filterChipUtils';
import Chip from '@/components/chip';
import type {GroupedDisplayItems} from '../active-filters-bar/displayItemTypes';
import styles from './FilterChipsList.module.scss';

type FilterChipsListProps = {
  groupedDisplayItems: GroupedDisplayItems[];
};

function FilterChipsList({groupedDisplayItems}: FilterChipsListProps) {
  const hasItems = groupedDisplayItems.length > 0;
  if (!hasItems) {
    return null;
  }

  return (
    <div className={styles.container}>
      {groupedDisplayItems.flatMap(({items}) =>
        items.map((item) => (
          <Chip
            key={getItemKey(item)}
            label={getChipLabel(item)}
            sx={{borderColor: 'transparent !important'}}
            size="small"
          />
        ))
      )}
    </div>
  );
}

export default FilterChipsList;
